<template>
  <!--begin::Content wrapper-->
  <div
    dir="rtl"
    class="modal fade forgetpassword-modal"
    id="icash-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            الشحن بإستخدام iCash
          </h5>
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">
                          <i class="fa fa-close"></i>      إغلاق
                     </button>
        </div>
        <div class="modal-body">
          <div class="support-box text-center">
            <img
              class="icon-img text-center"
              src="assets/img/icash.png"
              alt=""
            />
          </div>
          <h4 class="mb-2 text-center support-text">
            <div class="mb-2">بطاقات أي كاش | iCash</div>
            <br />
            <span style="color: #9d9d9d"> أدخل أدناه بيانات البطاقة </span>
          </h4>

          <form @submit.prevent="handleSubmit" class="form-horizontal">
            <div class="row" dir="rtl">
              <div class="col-md-12">
                <div class="form-group form-group-custom mb-4" dir="rtl">
                  <label for="icash-code">رمز التعبئة </label>
                  <input
                    type="text"
                    class="form-control"
                    id="icash-code"
                    v-model="code"
                    placeholder="XXXXXXXXX"
                  />
                </div>
                <div class="form-group form-group-custom mb-4" dir="rtl">
                  <label for="icash-value">قيمة الكرت </label>
                  <input
                    type="text"
                    class="form-control"
                    id="icash-value"
                    v-model="value"
                    placeholder="XXXXXXXXX"
                  />
                </div>

                <div class="mt-2"></div>
              </div>
            </div>
            <hr>
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              عودة
            </button>
            <button
              class="btn btn-primary waves-effect waves-light float-end btn-charge"
              type="submit"
              :disabled="isLoading"
            >
              تعبئة <i class="fa fa-plus"></i>
              <span
                v-if="isLoading"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!--end::Content wrapper-->
</template>

<script>
import Swal from "sweetalert2";
import { apiUrl } from "@/utils/api"; // Adjust the import path according to your project structure

export default {
  name: "Icash",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      code: "",
      value: "",
      isLoading: false,
    };
  },
  mounted() {
    $("#icash-modal").on("show.bs.modal", () => {
      $("#payments-modal").modal("hide");
    });
  },
  methods: {
    async handleSubmit() {
      try {
        const result = await Swal.fire({
          title: "هل أنت متأكد من العملية؟",
          text: " ",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3ddc97",
          cancelButtonColor: "#f46a6a",
          cancelButtonText: "لا",
          confirmButtonText: "نعم",
        });

        if (result.isConfirmed) {
          this.isLoading = true;

          const response = await fetch(`${apiUrl}/e-payment/icash`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.token}`,
            },
            body: JSON.stringify({
              code: this.code,
              value: this.value,
            }),
          });

          if (!response.ok) {
            const errorResponse = await response.json();
            throw errorResponse;
          }

          Swal.fire({
            icon: "success",
            title: "تم شحن المحفظة بنجاح",
            text: "",
          }).then((result) => {
            if (result.isConfirmed) {
              location.reload();
            }
          });
          this.isLoading = false;
 
        }
      } catch (error) {
        this.isLoading = false;

        if (error.errors) {
          const errors = error.errors;
          if (errors.code === "هذا الكرت غير صالح") {
            Swal.fire("هذا الكرت غير صالح", "", "error");
          } else {
            Object.values(errors).forEach((errorMessage) => {
              Swal.fire("خطأ", errorMessage.join(", "), "error");
            });
          }
        } else {
          Swal.fire("خطأ", "حدث خطأ ما. الرجاء المحاولة مرة أخرى.", "error");
        }
      }
    },
  },
};
</script>

<style scoped>
.icon-img {
  margin-bottom: 10px;
  width: 150px;
}
#icash-code,
#icash-value {
  text-align: center;
  border: 0px;
  background: #ededed;
  height: unset;
}
.btn-charge {
  padding: 10px 50px;
  font-weight: 600;
  background: rgb(60 88 129);
}
</style>
